import React from 'react';
import { DetailsItem, DetailsLabel, DetailsLayout, DetailsText, ProjectDetailsCont } from './ProjectDetails.styles';
import { Box, Paper } from '@material-ui/core';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { Skeleton } from '@material-ui/lab';

const ProjectDetailsLoader = () => {
  //generate array or 2 items
  return (
    <ProjectDetailsCont>
      <CustomTypography style={{ fontWeight: 500 }}>Project Overview</CustomTypography>
      <DetailsLayout style={{ minHeight: 100 }}>
        <DetailsItem maxwidth={215} style={{ minWidth: 215 }}>
          <DetailsLabel>Conflict:</DetailsLabel>
          <Skeleton variant="text" width={215} height={20} />
          <Skeleton variant="text" width={215} height={20} />
          <Skeleton variant="text" width={215} height={20} />
        </DetailsItem>
        <DetailsItem bordered={1} maxwidth={450}>
          <DetailsLabel>Usage/Run:</DetailsLabel>
          <Skeleton variant="text" width={215} height={20} />
          <Skeleton variant="text" width={215} height={20} />
          <Skeleton variant="text" width={215} height={20} />
        </DetailsItem>
        <DetailsItem maxwidth={410}>
          <DetailsLabel>Additional Details:</DetailsLabel>
          <Skeleton variant="text" width={215} height={20} />
          <Skeleton variant="text" width={215} height={20} />
          <Skeleton variant="text" width={215} height={20} />
        </DetailsItem>
        <DetailsItem maxwidth={410} left={1}>
          <DetailsLabel>Reference Media:</DetailsLabel>
          <Box style={{ display: 'flex', gap: 10 }}>
            {Array.from({ length: 2 }).map((_, i) => (
              <Skeleton key={i} variant="rect" height={50} style={{ flex: 1 }} />
            ))}
          </Box>
        </DetailsItem>
      </DetailsLayout>
    </ProjectDetailsCont>
  );
};

export default ProjectDetailsLoader;
